export const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

export function liters(value) {
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
  }).format(Math.round(value));
}

export function compactLiters(value) {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(value >= 10_000_000 ? 1 : 2)}M L`;
  }

  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(0)}k L`;
  }

  return `${Math.round(value)} L`;
}

export function runtime(seconds) {
  const total = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  return [hours, minutes, secs].map((part) => String(part).padStart(2, "0")).join(":");
}

export function percentFull(tank, volume = tank.volumeLiters) {
  return clamp(volume / tank.capacityLiters, 0, 1);
}

function horizontalAreaAtHeight(heightFraction) {
  const h = clamp(heightFraction, 0, 1) * 2;
  if (h <= 0) return 0;
  if (h >= 2) return 1;

  const segmentArea = Math.acos(1 - h) - (1 - h) * Math.sqrt(Math.max(0, 2 * h - h * h));
  return segmentArea / Math.PI;
}

export function horizontalHeightForVolume(volumeFraction) {
  const target = clamp(volumeFraction, 0, 1);
  let low = 0;
  let high = 1;

  for (let index = 0; index < 32; index += 1) {
    const mid = (low + high) / 2;
    if (horizontalAreaAtHeight(mid) < target) {
      low = mid;
    } else {
      high = mid;
    }
  }

  return (low + high) / 2;
}

export function fillHeightFraction(tank, volume = tank.volumeLiters) {
  const volumeFraction = percentFull(tank, volume);
  return tank.type === "horizontal-cylinder" ? horizontalHeightForVolume(volumeFraction) : volumeFraction;
}

export function tankStatus(tank) {
  if (tank.volumeLiters <= tank.redZoneLiters || tank.status === "critical") {
    return "critical";
  }

  if (tank.volumeLiters <= tank.warningLiters || tank.status === "warning") {
    return "warning";
  }

  if (tank.status === "offline") {
    return "offline";
  }

  return "normal";
}

export function statusLabel(status) {
  return {
    normal: "Normal",
    warning: "Warning",
    critical: "Critical",
    offline: "Offline",
    stopped: "Stopped",
    running: "Running",
  }[status] ?? status;
}

